import { CONSTANTS } from '../../constants/constants';

export const SBOM_CONSTANTS = {
  INGEST: {
    BINARIES_CAPTION:
      'Most unencrypted file types are supported. Try uploading a firmware image, compressed archive, virtual disk, or a single executable file.',
    SBOM_CAPTION: 'Supported SBOM formats are CycloneDX v1.1 through v1.7 (JSON and XML) and SPDX v2.1, v2.2, v2.3, v3.0, v3.0.1 (JSON and Tag).',
    DOCUMENTATION_URL: 'https://kb.netrise.io/netrise-platform-coverage-document' // TODO: add documentation url
  },
  ALLOWED_VALUES: {
    MESSAGE: 'must be equal to one of the allowed values',
    MESSAGE_TO_SHOW: 'Must be equal to one of the '
  },
  BE: {
    VERSION: {
      BASE: 'VERSION_V',
      DEFAULT: 'VERSION_UNSPECIFIED'
    },
    FORMAT: {
      JSON: 'FORMAT_JSON',
      XML: 'FORMAT_XML',
      SPDX: 'FORMAT_TAG'
    }
  },
  BINARY: 'BINARY',
  BOM_FORMAT: 'CycloneDX',
  CHECKSUM: {
    ALGORITHM: {
      MD5: 'MD5',
      SHA1: 'SHA-1',
      SHA256: 'SHA-256'
    }
  },
  CONTENT_TYPE: {
    TEXT_PLAIN: 'text/plain'
  },
  CREATORS: {
    ORGANIZATION: 'Organization',
    PERSON: 'Person',
    TOOL: 'Tool'
  },
  DATA_LICENSE: 'CC0-1.0',
  DESCRIBES: 'DESCRIBES',
  DOWNLOAD: {
    ALREADY_IN_PROGRESS_MESSAGE: 'SBOM generation already in progress',
    SUCCESS_MESSAGE: 'generated successfully, download initiated',
    DOWNLOAD_SUCCESS: 'generated successfully, download finished.'
  },
  ENCODING: 'base64', //means types that shouldn't show everything in the reports page.
  EXTENSIONS: {
    VALID_EXTENSIONS: ['json', 'xml', 'spdx', 'bom', 'sbom'],
    JSON: 'json',
    XML: 'xml',
    SPDX: 'spdx',
    BOM: 'bom',
    SBOM: 'sbom',
    CYCLONE_DX: 'cdx'
  },
  FORM_TYPE: {
    SBOM: 'SBOM',
    FIRMWARE: 'FIRMWARE'
  },
  CYCLONE_DX_VERIFICATION_JSON: 'CycloneDX',
  CYCLONE_DX_VERIFICATION_XML: '<bom xmlns="http://cyclonedx.org/',
  ERROR_VALIDATION_FROM_USER: 'This document is not an XML or JSON document. If the SBOM is in SPDX Tag format set the extension to .spdx',
  SPDX_VERIFICATION_TAG: '"SPDXVersion: SPDX',
  FILE_NAME: 'SBOM',
  METADATA: {
    TOOLS: {
      NAME: 'NetRise Turbine',
      VENDOR: 'NetRise'
    },
    COMPONENT: {
      TYPE: {
        FIRMWARE: 'firmware'
      }
    }
  },
  NOASSERTION: 'NOASSERTION',
  PART_TYPES: {
    APPLICATION: 'application',
    OPERATIVE_SYSTEM: 'operating system'
  },
  SERIAL_NUMBER_START: 'urn:uuid:',
  SPDX_REF: 'SPDXRef',
  SPDX_REF_DOCUMENT: 'SPDXRef-DOCUMENT',
  SPDX_REF_PACKAGE: 'SPDXRef-Package',
  SPDX_DOCUMENT_VERSION: 'SPDX-2.2',
  SPEC_VERSION: '1.3',
  TYPES: {
    CYCLONE_DX: 'Cyclone DX',
    SPDX: 'SPDX'
  },
  XMLNS: 'http://cyclonedx.org/schema/bom/1.3',
  SBOM_STANDARD: {
    CYCLONEDX: 'CYCLONEDX',
    SPDX: 'SPDX'
  },
  CYCLONEDX_VERSION: {
    V1_6: 'VERSION_V1_6',
    V1_7: 'VERSION_V1_7'
  },
  SPDX_VERSION: {
    V3_0_1: 'VERSION_V3_0_1',
    V3_0: 'VERSION_V3_0',
    V2_3: 'VERSION_V2_3'
  },
  CYCLONEDX_VERSION_OPTIONS: [
    { key: 'V1_7', label: '1.7' },
    { key: 'V1_6', label: '1.6' }
  ],
  SPDX_VERSION_OPTIONS: [
    { key: 'V3_0_1', label: '3.0.1' },
    { key: 'V2_3', label: '2.3' }
  ],
  SBOM_FORMAT: {
    JSON: 'FORMAT_JSON',
    XML: 'FORMAT_XML',
    TAG: 'FORMAT_TAG'
  },
  FILE_FORMAT: {
    FORMAT_JSON: 'JSON',
    FORMAT_XML: 'XML',
    FORMAT_TAG: 'TAG'
  },
  TYPE_COLUMN_MAP: {
    APPLICATION: 'Application',
    FRAMEWORK: 'Framework',
    LIBRARY: 'Library',
    KERNEL: 'Kernel',
    KERNEL_MODULE: 'Kernel Module',
    PACKAGE: 'Package',
    OPERATING_SYSTEM: 'Operating System',
    FIRMWARE: 'Binary',
    SBOM: 'SBOM',
    ROOT: 'Root',
    AI_MODEL: 'AI Model'
  },
  COMPONENT_TYPE: {
    ROOT: 'ROOT'
  },
  TYPE_COLUMN_FILTER_VALUES: [
    {
      title: 'AI Model',
      value: 'AI_MODEL'
    },
    {
      title: 'Application',
      value: 'APPLICATION'
    },
    {
      title: 'Container',
      value: 'CONTAINER'
    },
    {
      title: 'Device',
      value: 'DEVICE'
    },
    {
      title: 'Framework',
      value: 'FRAMEWORK'
    },
    {
      title: 'Kernel',
      value: 'KERNEL'
    },
    {
      title: 'Kernel Module',
      value: 'KERNEL_MODULE'
    },
    {
      title: 'Library',
      value: 'LIBRARY'
    },
    {
      title: 'Operating System',
      value: 'OPERATING_SYSTEM'
    },
    {
      title: 'Package',
      value: 'PACKAGE'
    },
    {
      title: 'Root',
      value: 'ROOT'
    }
  ],
  SCOPE_COLUMN_FILTER_VALUES: [
    {
      title: 'Compile',
      value: 'COMPILE'
    },
    {
      title: 'Conditional',
      value: 'CONDITIONAL'
    },
    {
      title: 'Development',
      value: 'DEVELOPMENT'
    },
    {
      title: 'Other',
      value: 'OTHER'
    },
    {
      title: 'Runtime',
      value: 'RUNTIME'
    },
    {
      title: 'Test',
      value: 'TEST'
    }
  ],
  EXTENSION_TO_VALIDATE: {
    CDX_JSON: '.cdx.json',
    CYCLONE_DX_JSON: '.cyclonedx.json',
    SPDX_JSON: '.spdx.json'
  },
  VALIDATION: {
    XML: {
      ADDITIONAL_PROPERTY: 'Additional properties not allowed'
    }
  },
  MODAL: {
    REMOVE_COMPONENT: 'Remove Component'
  },
  CBOM_SPEC: {
    CYCLONEDX_V1_6: 'VERSION_V1_6'
  }
};

export const SBOM_TYPES = [
  CONSTANTS.TABLE.ASSETS.TYPES.SPDX_JSON,
  CONSTANTS.TABLE.ASSETS.TYPES.SPDX_TAG,
  CONSTANTS.TABLE.ASSETS.TYPES.CYCLONE_DX_JSON,
  CONSTANTS.TABLE.ASSETS.TYPES.CYCLONE_DX_XML,
  CONSTANTS.TABLE.ASSETS.TYPES.SBOM
];
